<template>
  <div class="loginBox">
    <div class="loginForm">
      <!-- <img src="~@/assets/images/logo.png"/> -->
      <van-field
        v-model="form.phone"
        type="number"
        clearable
        center
        :left-icon="require('@/assets/img/huaxia/phone.png')"
        placeholder="请输入手机号码"
      />
      <van-field
        v-model="form.captchaCode"
        center
        clearable
        :left-icon="require('@/assets/img/huaxia/yzm.png')"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <!-- <van-button size="small" type="primary">发送验证码</van-button> -->
          <div v-if="!timer" @click="getCodeMeds">发送验证码</div>
          <van-count-down v-else :time="timer" @finish="timer = 0" />
        </template>
      </van-field>
      <van-field
        v-model="form.bankCardNo"
        type="number"
        clearable
        center
        :left-icon="require('@/assets/img/huaxia/phone.png')"
        placeholder="请输入银行卡号"
      />
      <van-button
        class="formButton"
        loading-text="加载中..."
        :loading="loading"
        @click="submit()"
      >
        校验权益
      </van-button>
    </div>
    <div class="rule">
      <img src="@/assets/img/huaxia/title.png" alt="" />

      <div>
        一、活动时间<br />
        2025年1月1日至2025年6月30日
      </div>
      <div>
        二、活动对象<br />
        华夏银行信用卡持卡客户，易达金客户
      </div>
      <div>
        三、活动内容<br />
        活动期间,华夏银行信用卡持卡人通过账单分期，分期金额达标将获得相关权益（N选1）
      </div>
      <div>
        四、活动细则<br />
        1、以上权益需客户达标之后，通过添加我部企业微信客服号，进行达标条件核实，核实无误之后，将通过企业微信将权益派发给到客户。<br />
        2、本次活动名额有限，先到先得，额满即止。<br />
        3、精英环球卡（万事达版）、智程VISA卡等外币卡种不参与此活动。<br />
      </div>
    </div>
  </div>
</template>
<script>
import { getCaptcha, login } from '@/api/huaxia'
export default {
  data() {
    return {
      form: {
        phone: undefined,
        captchaCode: undefined
      },
      timer: 0,
      loading: false
    }
  },
  methods: {
    async getCodeMeds() {
      const reg = /^1[3456789]\d{9}$/
      if (!this.form.phone && !reg.test(this.form.phone)) {
        this.$toast.fail('请填写正确的手机号')
        return
      }
      const { code } = await getCaptcha({
        phone: this.form.phone
      })
      if (code === 0) {
        this.timer = 60000
      }
    },
    async submit() {
      try {
        const form = this.form
        if (!form.phone || !form.captchaCode || !form.bankCardNo) {
          this.$toast.fail('手机号、验证码、银行卡不能为空')
          return
        }
        this.loading = true
        const { code, data } = await login(form)
        this.loading = false
        if (code === 0) {
          sessionStorage.setItem('huaxiaToken', data)
          this.$router.push({
            name: 'huaxiaRights',
            query: {
              phone: form.phone
            }
          })
        }
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.loginBox {
  min-height: 100vh;
  background: #fce7bd url('~@/assets/img/huaxia/bg.png') top center no-repeat;
  background-size: 100% auto;
  .loginForm {
    padding: 65% 38px 0px;
    .van-cell {
      background: #f5f7fd;
      border-radius: 20px;
      margin-bottom: 15px;
      &::after {
        border-bottom: none;
      }
    }
    .formButton {
      margin: 30% auto 35px;
      font-size: 16px;
      color: #fff1df;
      height: 40px;
      line-height: 40px;
      background: #030001;
      border-radius: 50px;
      text-align: center;
      cursor: pointer;
      width: 100%;
      display: block;
    }
  }
  .rule {
    margin: 37px 26px 0px;
    padding-bottom: 2px;
    img {
      display: block;
      width: 130px;
      margin: 0 auto 20px;
    }
    & > div {
      margin-bottom: 10px;
      font-size: 12px;
      color: #030001;
      line-height: 18px;
    }
  }
}
</style>
